// Wait for jQuery to be available before initializing tabs
(function() {
    var retryCount = 0;
    var maxRetries = 100; // 5 seconds max wait

    function initTabs() {
        if (typeof window.jQuery !== 'undefined' && window.jQuery.fn) {
            // jQuery is available, initialize tabs
            window.jQuery(document).ready(function($) {
                $('.tabs-wrapper > ul a[rel="tab"]').click(function(event) {
                    event.preventDefault();
                    $(this).parent().siblings().removeClass("current");
                    $(this).parent().addClass("current");

                    var tab = $(this).attr("href");

                    $(tab).siblings().css('display','none');
                    $(tab).fadeIn();
                });
            });
        } else if (retryCount < maxRetries) {
            // jQuery not yet available, retry in 50ms
            retryCount++;
            setTimeout(initTabs, 50);
        } else {
            console.error('ui-tabs.js: jQuery failed to load after 5 seconds');
        }
    }

    // Start initialization
    initTabs();
})();